import * as yup from "yup";

import { yup_password_factory } from "@/utils/yupSchemaUtils";

export const SET_PASSWORD_VALIDATION = yup.object().shape({
  password: yup_password_factory(),
  password_validation: yup
    .string()
    .required("Password Validation is required")
    .test("password-match", "Password does not match, please check spelling", function (value) {
      if (!value) {
        return false;
      }

      return this.parent.password === value;
    }),
});
